module.exports = __webpack_public_path__ + "img/generic-driver.58cd1dcb.svg";